import { render, staticRenderFns } from "./CufeDiscount.vue?vue&type=template&id=adc74bf2&scoped=true"
import script from "./CufeDiscount.vue?vue&type=script&lang=js"
export * from "./CufeDiscount.vue?vue&type=script&lang=js"
import style0 from "./CufeDiscount.vue?vue&type=style&index=0&id=adc74bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc74bf2",
  null
  
)

export default component.exports